<template>
    <v-col cols="12" class="CollaboratorDetail mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Portal de <span class="color-blue">Reportes</span></h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                </v-row>
                    <v-row>
                        <v-col cols="12" lg="4">
                            
                            <v-card class="elevation-0 report-detail mx-auto pa-5" min-height="400" >
                                <h4 class="font-weight-medium text-left title-reports my-6">Estado de mis card/reportes</h4>
                                <v-row>
                                    <v-col>
                                        <h1 class="number-reports font-family-2 text-center">
                                            5<span>/6</span>
                                        </h1>
                                    </v-col>
                                    <v-col>
                                        <p>
                                            reporte en<br>
                                             funcionamiento
                                        </p>
                                    </v-col>
                                </v-row>
                                <template>
                                    <v-data-table dense :headers="status.headers" :items="status.data" item-key="name" class="elevation-0 table-report-1"></v-data-table>
                                </template>
                            </v-card>

                        </v-col>
                        <v-col cols="12" lg="8">
                        <v-card class="elevation-0 report-detail mx-auto pa-5" min-height="400" >
                                <h4 class="font-weight-medium text-left title-reports my-6 ">Detalle de ventas</h4>
                                <v-sheet
                                dark
                                elevation="0"
                                class="mx-auto px-5"
                                height="50"
                                color="#7F03BB"
                                >
                                <v-row>
                                    <v-col>Mis pagos</v-col>
                                    <v-col>
                                        <v-row>
                                            <v-col cols="12" md="3" lg="2" class="pa-0">
                                                <p class="pa-0 color-white">
                                                    Periodo
                                                </p>
                                            </v-col>
                                            <v-col cols="12" md="9" lg="10" class="pa-0">
                                                <v-select
                                                        style="height:20px"
                                                        :items="['Enero - Febrero 2020','Febrero - Marzo 2020']"
                                                        placeholder="Selecciona una periodo."
                                                        dense
                                                ></v-select>

                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                
                                </v-sheet>
                                <template>
                                    <v-data-table dense :headers="sales.headers" :items="sales.data" item-key="name" class="elevation-0 table-report-1"></v-data-table>
                                </template>
                        </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">

.v-expansion-panel{
    background: #F2F2F2 !important;
    border-radius: 4px;
}
.v-expansion-panel-content{
    border: 1px solid #F2F2F2;
    background-color: #ffffff !important;
    }
.color-blue{
    color:#0172C0;
}
.number-reports{
    font-weight: 800;
    font-size:22px;
    color:#449926;
    span{
        font-size:18px;
        color:#E2E2E2;

    }
}
</style>
<script>
    export default {
        name: 'CollaboratorDetail',
        data: () => ({
            status:{
                data:[
                    {
                    name: 'Analisis de desempeño',
                    status:'pagado'
                    },
                    {
                    name: 'Puntos de retiro de energia',
                    status:'Aprobado'
                    },
                ],
                headers: [
                    {
                    text: 'Nombre del reporte',
                    value: 'name',
                    },
                    { text: 'Estado', value: 'status' },
                ],
            },
            sales:{
                data: [
                    {
                    name: 'Analisis de desempeño',
                    month: 'Agosto',
                    quantity: '15',
                    pesos: 120000,
                    status:'pagado'
                    },
                    {
                    name: 'Nombre de la unidad',
                    month: 'Septiembre',
                    quantity: '3',
                    pesos: 24000,
                    status:'pagado'
                    },
                    {
                    name: 'Puntos de retiro de energia',
                    month: 'Agosto',
                    quantity: '15',
                    pesos: 288000,
                    status:'Pendiente de Pago'
                    },
                
                ],
                headers: [
                    {
                    text: 'Nombre del reporte',
                    value: 'name',
                    },
                    { text: 'mes', value: 'month' },
                    { text: 'cantidad', value: 'quantity' },
                    { text: 'Pesos', value: 'pesos' },
                    { text: 'Estado', value: 'status' },
                ],
            }
            
            }),
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>